import { IconPropsType } from '..';

export const QuestionCircleIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      width="12"
      height="12"
      fill="#1E1E1E"
    />
    <g id="Withdrawals - history">
      <path
        d="M-1874 -1711C-1874 -1712.1 -1873.1 -1713 -1872 -1713H724C725.104 -1713 726 -1712.1 726 -1711V485C726 486.104 725.104 487 724 487H-1872C-1873.1 487 -1874 486.104 -1874 485V-1711Z"
        fill="#404040"
      />
      <path
        d="M-1872 -1712H724V-1714H-1872V-1712ZM725 -1711V485H727V-1711H725ZM724 486H-1872V488H724V486ZM-1873 485V-1711H-1875V485H-1873ZM-1872 486C-1872.55 486 -1873 485.552 -1873 485H-1875C-1875 486.657 -1873.66 488 -1872 488V486ZM725 485C725 485.552 724.552 486 724 486V488C725.657 488 727 486.657 727 485H725ZM724 -1712C724.552 -1712 725 -1711.55 725 -1711H727C727 -1712.66 725.657 -1714 724 -1714V-1712ZM-1872 -1714C-1873.66 -1714 -1875 -1712.66 -1875 -1711H-1873C-1873 -1711.55 -1872.55 -1712 -1872 -1712V-1714Z"
        fill="white"
        fillOpacity="0.1"
      />
      <g id="col">
        <rect
          width="730"
          height="376"
          transform="translate(-133 -342)"
          fill="#262A40"
        />
        <g id="col_2">
          <g id="line">
            <mask
              id="path-3-inside-1_1392_50978"
              fill="white"
            >
              <path d="M-123 -12H587V24H-123V-12Z" />
            </mask>
            <path
              d="M587 23H-123V25H587V23Z"
              fill="#2E334D"
              mask="url(#path-3-inside-1_1392_50978)"
            />
            <g id="Frame 2015">
              <g id="kb-core-icon">
                <path
                  id="Vector"
                  d="M5.48434 9.40458H6.60434V8.28458H5.48434V9.40458ZM6.04434 0.44458C4.93676 0.44458 3.85406 0.773014 2.93314 1.38835C2.01223 2.00369 1.29446 2.87829 0.870613 3.90155C0.446762 4.92482 0.335864 6.05079 0.551941 7.13708C0.768018 8.22338 1.30137 9.2212 2.08454 10.0044C2.86771 10.7875 3.86554 11.3209 4.95183 11.537C6.03812 11.7531 7.1641 11.6422 8.18736 11.2183C9.21063 10.7945 10.0852 10.0767 10.7006 9.15577C11.3159 8.23486 11.6443 7.15215 11.6443 6.04458C11.6443 5.30918 11.4995 4.58098 11.2181 3.90155C10.9366 3.22213 10.5241 2.60479 10.0041 2.08478C9.48413 1.56477 8.86679 1.15228 8.18736 0.870855C7.50794 0.589428 6.77974 0.44458 6.04434 0.44458V0.44458ZM6.04434 10.5246C5.15828 10.5246 4.29212 10.2618 3.55538 9.76956C2.81865 9.27729 2.24444 8.57761 1.90536 7.759C1.56628 6.94039 1.47756 6.03961 1.65042 5.17057C1.82328 4.30154 2.24996 3.50328 2.8765 2.87674C3.50304 2.2502 4.3013 1.82352 5.17033 1.65066C6.03937 1.4778 6.94015 1.56652 7.75876 1.9056C8.57737 2.24468 9.27705 2.81889 9.76932 3.55562C10.2616 4.29236 10.5243 5.15852 10.5243 6.04458C10.5229 7.23229 10.0504 8.37094 9.21054 9.21078C8.3707 10.0506 7.23205 10.5231 6.04434 10.5246V10.5246ZM6.04434 2.68458C5.45025 2.68458 4.8805 2.92058 4.46042 3.34066C4.04034 3.76074 3.80434 4.33049 3.80434 4.92458H4.92434C4.92434 4.62754 5.04234 4.34266 5.25238 4.13262C5.46242 3.92258 5.74729 3.80458 6.04434 3.80458C6.34138 3.80458 6.62626 3.92258 6.8363 4.13262C7.04634 4.34266 7.16434 4.62754 7.16434 4.92458C7.16434 6.04458 5.48434 5.90458 5.48434 7.72458H6.60434C6.60434 6.46458 8.28434 6.32458 8.28434 4.92458C8.28434 4.33049 8.04834 3.76074 7.62826 3.34066C7.20817 2.92058 6.63842 2.68458 6.04434 2.68458V2.68458Z"
                  fill="#F31680"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
